import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'operation';

const operationService = {
  createOperation: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  getOperations: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/operations`,
    });
  },

  getOperationByBaseLine: (baseLine) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/operationByBaseLine/${encodeURIComponent(baseLine)}`,
    });
  },

  getOperationsReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/operations`,
      data,
    });
  },

  updateOperation: (data, operationId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(operationId)}`,
      data,
    });
  },

  deleteOperation: (operationId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(operationId)}`,
    });
  },

  updateOperationUserLink: (operationId, userId) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/operationUserLink/${encodeURIComponent(operationId)}/${encodeURIComponent(userId)}`,
    });
  },
};

export default operationService;
